import { createSelector } from '@ngrx/store';
import { BaseState } from '../base.state';

export const selectPropertiesState = (state: BaseState) => state.properties;

export const selectPropertiesIsLoading = createSelector(
  selectPropertiesState,
  (state) => state.isLoading
);